export default __webpack_public_path__ + "images/139bfd457eed99761bbffc429010c196-cardio_icon.png";